import { images } from './../../assets/Images/index';

export const data = [
  {
    type: "pizza",
    img: images.p1,
    title: "Fusce dictum finibus",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "pizza",
    img: images.p2,
    title: "Aliquam sagittis",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$75 / $65",
  },
  {
    type: "pizza",
    img: images.p1,
    title: "Fusce dictum finibus",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "pizza",
    img: images.p3,
    title: "Sed varius turpis",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "pizza",
    img: images.p1,
    title: "Fusce dictum finibus",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$70 / $50",
  },
  {
    type: "pizza",
    img: images.p4,
    title: "Fusce dictum finibus",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "pizza",
    img: images.p3,
    title: "Sed varius turpis",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "salad",
    img: images.s1,
    title: "Salad Menu One",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "salad",
    img: images.s2,
    title: "Salad Menu Two",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "pizza",
    img: images.p3,
    title: "Sed varius turpis",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "noodle",
    img: images.n2,
    title: "Noodle Second",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "salad",
    img: images.s3,
    title: "Salad Menu Thired",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "salad",
    img: images.s4,
    title: "Salad Menu Fourth",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "salad",
    img: images.s1,
    title: "Salad Menu One",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "noodle",
    img: images.n1,
    title: "Noodle One",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "salad",
    img: images.s1,
    title: "Salad Menu One",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "noodle",
    img: images.n2,
    title: "Noodle Second",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "noodle",
    img: images.n4,
    title: "Salad Menu Fourth",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "noodle",
    img: images.n3,
    title: "Third Soft Noodle",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "noodle",
    img: images.n2,
    title: "Noodle Second",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
  {
    type: "noodle",
    img: images.n4,
    title: "Salad Menu Fourth",
    description:
      "Nam in suscipit nisi, sit amet consectetur metus. Ut sit amet tellus accumsan",
    price: "$45 / $55",
  },
];
